<template>
  <div class="layout-main" :class="{ 'is-open': isSideMenuOpen }">
    <aside class="layout-main__sidebar u-pt">
      <div class="u-ph">
        <img src="@/assets/images/logo.png" alt="SDOS" width="140px" class="">
      </div>
      <side-menu />
    </aside>
    <main class="layout-main__main u-mb-large">
      <div class="layout-main__header u-mb-large">
        <main-header-nav @toggleSideMenu="toggleSideMenu" />
      </div>
      <div class="layout-main__content u-mb">
        <div class="u-ph">
          <h1 class="u-bb u-pb-large">Listado de usuarios</h1>
        </div>
        <user-table @goToUserEdit="goToUserEdit($event)"/>
      </div>
      <div class="layout-main__overlay" @click="toggleSideMenu"></div>
    </main>
  </div>
</template>

<script>
import MainHeaderNav from '@/components/navs/main-header-nav'
import SideMenu from '@/components/navs/side-menu'
import UserTable from '@/components/tables/user-table'

export default {
  name: 'userIndex',

  components: {
    MainHeaderNav,
    SideMenu,
    UserTable
  },

  created() {
    if(!this.$store.state.user.users.length > 0) {
      this.$store.dispatch('user/fetchUsers')
    }
  },

  data() {
    return {
      isSideMenuOpen: false
    }
  },

  methods: {
    goToUserEdit(user) {
      this.$store.commit('user/SET_USER', user)
      this.$router.push({ name: 'userEdit', params: { id: user.id } })
    },

    toggleSideMenu() {
      this.isSideMenuOpen = !this.isSideMenuOpen
    }
  }
}
</script>
